import {Component, Injector, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {TravelReRoute} from "../../../../model/travel/travel-reroute.model";
import { DocumentField } from '../../../../model/document-field';
import { ClaimTypes } from '../../../../model/claim-type.model';
import { DocumentHelperService } from "../../../../services/document-helper.service";
import {UtilitiesService} from '../../../../utilities/utilities.service';

@Component({
    selector: 'app-summary-travel-reroute',
    templateUrl: './summary-travel-reroute.component.html',
    styleUrls: ['./summary-travel-reroute.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class SummaryTravelRerouteComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    travelReRoute: TravelReRoute;
    listOfDocuments: DocumentField[] = [];
    listOfOtherDocuments: DocumentField[] = [];
    @Input() claimItem: Claim;

    constructor(private claimService: ClaimService,
                private documentHelperService: DocumentHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();

    }
    
    ngOnInit() {

        if (!UtilitiesService.isNullOrUndefined(this.claimItem)) {
            this.claim = this.claimItem;
        } else {
            this.claim = this.claimService.getClaim();
        }

        this.travelReRoute = this.claim.getClaimTravel().getTravelReRoute();
        let isClaimantMinor = UtilitiesService.isMinor(this.claim.getClaimantDateOfBirth());
        this.listOfDocuments = this.documentHelperService.getListOfUploadedDocumentsClaimant(this.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT], isClaimantMinor);
        this.listOfOtherDocuments = this.documentHelperService.getListOfOtherUploadedDocuments(this.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_CAN_RROUT]);

    }

    
    returnConvertValue(value: string) {
        if ('Cancelled' === value) {
            return this.translate.instant("claimSection.reroute.cancelOrDelay.cancel");
        } else {
            if ('Delayed' === value) {
                return this.translate.instant("claimSection.reroute.cancelOrDelay.delay");
            }
        }
        return '';
    }

    
    returnYesOrNo(value: string) {
        if ('Yes' === value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if ('No' === value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy HH:mm");
        }
        else {
            return "";
        }
    }

}
